<template>
  <div class="create-folder">
    <el-dropdown
      v-show="isShowHeader && !fromCopyMove && !isCreateFolderDisable"
      placement="bottom-start"
      :show-overflow-tooltip="true"
      @command="createFile"
      @visible-change="visibleChange"
    >
      <div
        id="create-file"
        class="lv-btn primary-btn"
        :class="{'disabled': isCreateFolderDisable}"
      >
        {{ $t('新建') }}<i class="icon-caret_down" />
      </div>
      <el-dropdown-menu
        slot="dropdown"
        class="el-dropdown-menu create-dropdown"
      >
        <div
          v-for="(opt,index) in createFileOpt"
          :key="index"
        >
          <li
            v-if="index === 'word'"
            class="line"
          />
          <el-dropdown-item
            v-if="index!=='topTplFile'"
            v-show="opt.show"
            :command="{
              dialogTitle: opt.name,
              filename: opt.fullName,
              inputLable: opt.placeholder,
              fileType: opt.type,
              i: index
            }"
          >
            <span
              class="item"
              :title="$t(opt.tag)"
            >
              <svg :class="opt.icon">
                <use :xlink:href="'#' + opt.icon" />
              </svg>
              {{ $t(opt.tag) }}
            </span>
          </el-dropdown-item>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
    <!-- 新建文件夹的弹窗 -->
    <div
      v-if="show && dcType"
      class="confirm-dialog"
      :style="{left: left + 'px', top: top + 'px'}"
    >
      <div class="confirm-header">
        <span class="confirm-title">{{ $t(dialogTitle) }}</span>
        <span
          class="confirm-close"
          @click="close"
        />
      </div>
      <div class="confirm-body">
        <div class="folderName">
          <span>{{ $t(inputLable) }}</span>
          <input
            v-model="filename"
            type="text"
            class="filename-input"
            :class="{'input-error': !!errorMsg}"
            autofocus
            :placeholder="$t('新建文件夹')"
            @focus="nameFocusHandler"
          >
        </div>
        <div
          v-show="errorMsg"
          class="error-message"
        >
          {{ $t(errorMsg) }}
        </div>
        <div class="dcSelect">
          <span>{{ $t('数据中心') }}</span>
          <el-select
            v-model="dcId"
            v-ie-placeholder
            :placeholder="$t('请选择')"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
      </div>
      <div class="confirm-footer">
        <div
          class="confirm-btn lv-btn default-btn"
          @click="close"
        >
          {{ $t('取消') }}
        </div>
        <div
          class="confirm-btn lv-btn primary-btn"
          @click="createFolder"
        >
          {{ $t('确定') }}
        </div>
      </div>
    </div>
    <div
      v-if="show && dcType"
      class="dialog-wrapper"
    />
    <folderTpl
      ref="tplToFolder"
      @getCreateData="getCreateData"
      @refreshList="refreshList"
      @showTips="showTips"
    />
  </div>
</template>
<script>
/* eslint-disable guard-for-in */


import * as Util from 'js/util/util'
import folderTpl from 'components/common/folderTemplate/index.vue'
import store from 'store'

const { postData, getData } = require('js/api/getdata').default
const { listMode } = require('js/createFolder/listMode.js').default

export default {
  components: {
    folderTpl,
  },
  props: {
    currentPath: String,
    goalNode: {
      type: Object,
      default: () => ({}),
    },
    fromCopyMove: {
      type: Boolean,
      default: false,
    },
    pathType: String,
    folderDcType: Number,
    from: [Number, String],
    prefix_neid: [Number, String],
    isCreateFolderDisable: {
      type: Boolean,
      default: false,
    },
    isShowHeader: Boolean,
  },
  data() {
    return {
      /* 初始化配置参数 */
      createFileOpt: {
        folder: {
          tag: '文件夹',
          name: '新建文件夹',
          fullName: '',
          placeholder: '文件夹名称',
          type: '',
          show: true,
          icon: 'folder',
        },
        template: {
          tag: '从模板创建文件夹',
          name: '',
          fullName: '',
          placeholder: '',
          type: 'tpl',
          vm: this,
          get show() {
            const { vm } = this
            const { pathType } = vm
            if (pathType === 'self' || pathType === 'share_in' || pathType === 'share_out') {
              return false // 个人空间，我的共享，收到的共享删除‘从模板创建文件夹’入口
            }
            return true
          },
          icon: 'template-folder',
        },
        word: {
          tag: 'Word文档',
          name: '新建Word文档',
          fullName: '新建 Microsoft Word 文档',
          placeholder: '文件名称',
          type: 'docx',
          vm: this,
          get show() {
            return this.vm.showWord
          },
          icon: 'word',
        },
        excle: {
          tag: 'Excel文档',
          name: '新建Excel文档',
          fullName: '新建 Microsoft Excel 文档',
          placeholder: '文件名称',
          type: 'xlsx',
          vm: this,
          get show() {
            return this.vm.showWord
          },
          icon: 'excel',
        },
        ppt: {
          tag: 'PowerPoint文档',
          name: '新建PowerPoint文档',
          fullName: '新建 Microsoft PowerPoin 文档',
          placeholder: '文件名称',
          type: 'pptx',
          vm: this,
          get show() {
            return this.vm.showWord
          },
          icon: 'ppt',
        },
        topTplFile: [

        ],
      },
      filename: '',
      show: false,
      MenuShow: false,
      left: '',
      top: '',
      fileType: '',
      dialogTitle: '新建文件夹',
      inputLable: '文件夹名称',
      createType: 'createFolder',
      dcType: false,
      options: [],
      dcId: '',
      errorMsg: '',
      topTemplateList: '', // 置顶模板数组
      Util,
    }
  },
  computed: {
    showWord() {
      return this.folderDcType !== 4 // 融合云目录不能有文件
    },
    currentDirNeid() {
      return store.state.currentData.neid
    },
    folder_dc_type() {
      return store.state.currentData.folder_dc_type
    },
    currentRegionId() {
      return store.state.currentData.region_id
    },
    currentFolderNeid() {
      return store.state.currentData.neid
    },
    currentAccessMode() {
      return store.state.currentData.access_mode
    },
  },
  watch: {
    show(val) {
      if (this.dcType && Util.isClient()) {
        const WndName = 'MainWndTitle'
        const Operate = val ? 'hide' : 'show'
        Util.controlClientWnd(Operate, WndName)
      }
    },
  },
  methods: {
    init() {
      if (this.fromCopyMove) {
        const currentNode = this.goalNode
        this.dcType = false
        const data = {
          pathType: currentNode.path_type,
          disable_rename: 'false',
          dcId: this.dcId,
          fileType: currentNode.fileType || '',
          filename: '',
          currentPath: currentNode.path,
          from: currentNode.from || '',
          prefix_neid: currentNode.prefix_neid || '',

        }
        this.$emit('addNewFolderNode', (nd) => {
          listMode(data, this, nd)
        })
        return
      }
      this.dcType = false
      const data = {
        pathType: this.pathType,
        disable_rename: 'false',
        dcId: this.dcId,
        fileType: this.fileType || '',
        filename: this.filename,
        currentPath: localStorage.getItem('currentPath'),
        from: this.from || '',
        prefix_neid: this.prefix_neid || '',

      }
      listMode(data, this)
      // }
    },
    setPos() {
      this.left = (window.innerWidth - 400) / 2
      this.top = (window.innerHeight) / 3
    },
    toggleMenu() {
      this.MenuShow = !this.MenuShow
    },
    close() {
      this.$emit('delNewFolderNode')
      this.show = false
    },
    createFile(param) {
      // 增加参数item 为置顶模板数据
      const {
        dialogTitle, filename, inputLable, fileType, i,
      } = param
      if (i === 'template') {
        this.$refs.tplToFolder.dialogShow()
        return
      }
      if (i === 'templateFile') {
        this.$refs.tplToFile.dialogShow()
        return
      }
      this.dialogTitle = dialogTitle
      this.filename = filename
      this.inputLable = inputLable
      this.fileType = fileType
      this.init(fileType)
      this.show = true
      this.setPos()
    },
    showErr(str) {
      if (this.show && this.dcType) {
        this.errorMsg = str
      } else {
        this.$emit('showTips', str, 'warn')
      }
    },
    nameFocusHandler() {
      this.errorMsg = ''
    },
    createFolder(filename, info) {
      // 还可能传mouseevent
      if (typeof filename === 'string') {
        this.filename = filename
      }
      if (!this.fileType) {
        this.filename = this.filename.trimRight() // 新建文件夹时文件夹末尾的空格去掉
        if (Util.validFolderName(this.filename) === false) {
          this.showErr(`${this.$t('文件夹名称不能包括下列任何字符')}: \\/:*?"<>|`)
          // this.$emit('showTips', '文件夹名称不能包括下列任何字符: \\\/:*?"<>|' , 'warn')
          return
        }
      } else if (Util.validFilename(this.filename) === false) {
        this.$emit('showTips', `${this.$t('文件名称不能包括下列任何字符')}: \\/:*?"<>|`, 'warn')
        return
      }
      if (!Util.validEmpty(this.filename)) {
        this.showErr(this.$t('文件夹名不能为空或空格'))
        return
      }
      if (this.filename.trim().startsWith('.')) {
        this.$emit('showTips', this.$t('文件或文件夹名称不能以.开头'), 'warn')
        return
      }
      // 公有原来的参数
      const data = {
        path_type: this.pathType || this.goalNode.path_type,
        neid: '',
        disable_rename: 'false',
        dc_id: this.dcId,
        file_type: this.fileType || '',
        from: this.from || this.goalNode.from || '',
        prefix_neid: this.prefix_neid || this.goalNode.prefix_neid || '',
      }
      // 私有新建文件参数
      const fileData = {
        file_type: this.fileType || '',
        dc_url: '',
        path: '',
        path_type: this.pathType,
        template_name: this.filename,
        from: this.from || '',
        prefix_neid: this.prefix_neid || '',
        nsid: store.state.tempFileListState.tempNsid,
      }
      // 私有新建文件夹参数
      const folderData = {
        is_update: false,
        path_type: this.pathType || this.goalNode.path_type,
        nsid: store.state.tempFileListState.selectNsid,
        pid: store.state.tempFileListState.selectPid,
      }
      let fileSize // 私有字段(验证上传权限)
      switch (this.fileType) {
        case 'docx':
          fileSize = 14406
          break
        case 'xlsx':
          fileSize = 10423
          break
        case 'pptx':
          fileSize = 26820
          break
        default:
          fileSize = 0
      }

      if (this.fileType === '' || this.fileType === undefined) {
        this.createType = 'createFolder'
      } else {
        this.createType = 'createFile'
      }
      let urlTail; const param = {}; const
        path = localStorage.getItem('currentPath')

      if (data.file_type !== '') {
        urlTail = `${path}/${this.filename}.${data.file_type}`
      } else if (this.currentPath) {
        urlTail = `${this.currentPath}/${this.filename}`
      } else {
        urlTail = `${path}/${this.filename}`
      }
      // 私有新建文件需要验证有无上传权限，故使用以下方法
      if (this.createType === 'createFolder') {
        // 新建文件夹
        if (info.pathType === 'share_in') {
          folderData.prefix_neid = info.prefix_neid
          folderData.from = info.from
        }
        folderData.targetPath = urlTail
        postData('createFolder', folderData).then((res) => {
          if (res.status === 200) {
            this.$emit('showTips', this.$t('成功创建“{name}”文件夹', { name: Util.pathToName(res.data.path) }), 'success')
            // --以下为移动复制中新建文件夹逻辑，之前调试过了，由于公有修改 暂注释，后面调试---
            // if (this.currentPath !== undefined) {
            //     let goalData = [
            //         this.goalNode,
            //         Util.pathToName(res.data.path),
            //         this.currentPath + '/' + Util.pathToName(res.data.path),
            //         res.data.neid,
            //         res.data.path_type,
            //         this.goalNode.access_mode,
            //         res.data.from,
            //         res.data.prefix_neid];
            //     this.$emit('append', ...goalData)
            // }
            // this.$emit('refreshList',{refresh: true,neid: this.$route.params.id})
            // this.close();
            //  ---------------------------------------结束----------------------------------------
            //  ===============以下 需要调试========================
            const { data: createFolderData } = res
            const params = {
              nsid: createFolderData.nsid,
              neid: createFolderData.neid,
              url: createFolderData.path,
              path_type: createFolderData.path_type,
              prefix_neid: createFolderData.prefix_neid,
              limit: '',
              offset: 0,
              include_deleted: false,
            }
            if (info.pathType === 'share_in') {
              params.prefix_neid = info.prefix_neid
              params.from = info.from
            }
            getData('getMetadata', params).then((metaDataRes) => {
              if (metaDataRes.status === 200) {
                const self = this
                const newFolderData = metaDataRes.data
                delete newFolderData.content
                newFolderData.isfolder = newFolderData.is_dir
                newFolderData.isDir = newFolderData.is_dir
                newFolderData.checked = false
                newFolderData.islocked = !!newFolderData.lock_uid
                newFolderData.unlockAdmin = (newFolderData.lock_uid === Util.getUserID())
                || Util.isAdmin()
                newFolderData.data = [{
                  type: 'file',
                  showRename: false,
                  get value() {
                    return newFolderData.filename ? newFolderData.filename : newFolderData.path.split('/').pop()
                  },
                  fileMore: [],
                  class: 'filelist-icon',
                }, {
                  get value() {
                    if (self.listMode) {
                      return `${Util.formatDate(newFolderData.modified, 'yyyy-MM-dd hh:mm')} | ${newFolderData.updator}`
                    }
                    if (newFolderData.isfolder) {
                      return Util.formatDate(newFolderData.modified, 'yyyy-MM-dd hh:mm')
                    }
                    return Util.formatDate(newFolderData.modified, 'yyyy-MM-dd hh:mm') + self.$t(' 由{n}创建', { n: newFolderData.updator })
                  },
                  class: 'update-date-updator',
                }, {
                  get value() {
                    return newFolderData.is_dir ? '-' : Util.formatBytes(newFolderData.bytes)
                  },
                  class: 'update-size',
                }]
                if (this.currentPath !== undefined) {
                  this.$emit('append', metaDataRes.data)
                  if (!Util.ifSearchPage()) { // 搜索列表下 移动复制弹框内的新建完成后不刷新列表
                    this.$emit('refreshList', { refresh: true, neid: this.$route.params.id })
                  }
                } else {
                  store.commit('addCreateData', newFolderData)
                  this.$emit('getCreateData', newFolderData)
                }
                this.close()
              }
            }).catch((error) => {
              console.log(error)
              const err = error.response.data
              this.$emit('showTips', err.message, 'error')
            })
          }
        }).catch((error) => {
          console.log(error)
          const err = error.response.data
          this.$emit('showTips', err.message, 'error')
          if (error.response.status === 400) {
            this.cancel()
          }
        })
      } else if (this.createType === 'createFile') {
        // 新建文件
        const authData = {
          path_type: this.pathType,
          bytes: fileSize,
          // 增加nsid
          nsid: store.state.tempFileListState.tempNsid,
        }
        authData.url = urlTail
        authData.target_path = urlTail
        fileData.path = urlTail
        // 先验证上传权限
        postData('getAuthUpload', authData, param).then((res) => {
          if (res.status === 200) {
            fileData.dc_url = res.data.region
            if (urlTail.indexOf('/') === 0) {
              fileData.path = urlTail.slice(1)
            } else {
              fileData.path = urlTail
            }
            postData(this.createType, fileData, param).then((createTypeRes) => {
              if (createTypeRes.status === 200) {
                this.cancel()
                this.$emit('showTips', this.$t('成功创建“{name}”文件', { name: this.filename }), 'success')
                let timer
                clearTimeout(timer)
                timer = setTimeout(() => {
                  this.$emit('refreshList', { url: this.currentPath, refresh: true })
                }, 300)
              }
            }).catch((error) => {
              const err = error.response.data
              this.$emit('showTips', err.message, 'error')
              if (error.response.status === 400) {
                this.cancel()
              }
            })
          }
        }).catch((error) => {
          const err = error.response.data
          this.$emit('showTips', err.message, 'error')
        })
      }
    },
    getDcList() {
      getData('getDcList', { accountId: store.getters.accountId }).then((res) => {
        this.options = []
        const dcInfo = res.data
        this.dcId = dcInfo[0].id
        for (let i = 0; i < dcInfo.length; i += 1) {
          const data = {
            value: dcInfo[i].id,
            label: dcInfo[i].alias,
          }
          this.options.push(data)
        }
      })
    },
    /**
             * @description 创建文件模板接口
             */
    createTplFile(filename, param) {
      const path = localStorage.getItem('currentPath')
      const urlTail = {
        templateid: param.id,
        folderNeid: this.currentFolderNeid,
        regionId: this.currentRegionId,
      }
      const data = {
        filepath: `${path}${path === '/' ? '' : '/'}${filename}`,
      }
      postData('tplFileCreateFile', data, urlTail).then((res) => {
        if (res.status === 200) {
          if (Util.canEditOL(this.currentAccessMode)) { // 判断在线编辑权限
            const editHref = `/edit?neid=${res.data.neid}`
            this.$emit('showTips', `${this.$t('创建成功！您可以通过docs编辑，在线编辑文件')} <a style='color:#2285ff' href=${editHref} target='_blank' id='editOutSide'>${this.$t('立即前往')}</a>`, 'notAutoClose')
          } else {
            this.$emit('showTips', this.$t('创建成功'))
          }
          this.$emit('refreshList', { refresh: true, neid: this.$route.params.id })
        }
      }).catch((error) => {
        const err = error.response.data
        if (err.state === 409) { // 重名
          this.$emit('showTips', this.$t('已有重名文件'), 'error')
        } else {
          this.$emit('showTips', err.message, 'error')
        }
      })
    },
    showTips(info, type) {
      this.$emit('showTips', info, type)
    },
    refreshList(neid) {
      const vm = this; let
        timer
      clearTimeout(timer)
      timer = setTimeout(() => {
        vm.$emit('refreshList', neid)
      }, 300)
    },
    /**
             * @description 获取模板列表 拿置顶得文件模板
             */
    getTplFileList() {
      const data = {
        offset: 0,
        limit: 50,
        _: Date.parse(new Date()),
        account_id: store.getters.accountId,
        uid: store.getters.uId,
        regionId: this.currentRegionId,
      }
      getData('tplFileList', data).then((res) => {
        if (res.status === 200) {
          const tempObj = res.data.filter((item) => {
            if (item.catagoryId === 'Top') {
              // top类型得为置顶模板
              return true
            }
            return false
          })
          if (tempObj && tempObj.length > 0) {
            this.topTplFileDataHandle(tempObj[0].templateList)
          }
        }
      })
    },
    /**
             * @description 置顶文件模板数据处理
             */
    topTplFileDataHandle(origin) {
      const tempArr = []
      const tempTypeMap = {
        doc: 'word',
        ppt: 'ppt',
        xls: 'excel',
        docx: 'word',
        pptx: 'ppt',
        xlsx: 'excel',
      }
      if (origin && origin.length > 0) {
        origin.forEach((item) => {
          const tempName = this.fileNameHandler(item.name)
          const tempObj = {
            tag: tempName,
            name: tempName,
            fullName: tempName,
            placeholder: '文件名称',
            type: item.fileExtension.split('.')[1],
            vm: this,
            show: true,
            icon: tempTypeMap[item.fileExtension.split('.')[1]],
            topTplData: item,
          }
          tempArr.push(tempObj)
        })
      }
      this.topTemplateList = tempArr
      this.createFileOpt.topTplFile = this.topTemplateList
    },
    /**
             * @description 文件名处理
             */
    fileNameHandler(fileName) {
      let tempName = ''
      if (fileName) {
        const reg = /.docx$|.doc$|.xlsx$|.xls$|.pptx$|.ppt$/i
        tempName = fileName.replace(reg, '')
      }
      return tempName
    },
    /**
             * @description 下拉框出现/隐藏时触发
             */
    visibleChange(isShow) {
      if (isShow) {
        // 公有置顶的文件模板，注释
        // this.getTplFileList();
      }
    },
    getCreateData(data) {
      this.$emit('getCreateData', data)
    },
  },
}
</script>
<style lang="less" scoped>
.create-folder {
  .el-dropdown {
    height: 56px;
  }
}
.dcSelect {
  margin-top: 20px;
  box-sizing: border-box;
}
.dialog-wrapper{
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.4);
  left: 0;
  top: 0;
  z-index: 1000;
}
.confirm-body {
  .error-message {
    color: red;
    margin-left: 116px;
    text-align: left;
    font-size: 12px;
  }
}
.confirm-dialog{
  position: fixed;
  z-index: 1001;
  font-size: 15px;
  border: 1px solid #d1d1d1;
  background: #fff;
  width: 450px;
  .confirm-header{
    background-color: #ffffff;
    height: 20px;
    line-height: 20px;
    color: #565656;
    border-radius: 3px 3px 0 0;
    padding: 24px;
    .confirm-title{
      display: inline-block;
      color: #575757;
      height: 20px;
      line-height: 20px;
      font-size: 18px;
    }
    .confirm-close{
      position: absolute;
      right: 24px;
      color: #565656;
      display: inline-block;
      width: 20px;
      height: 20px;
      vertical-align: middle;
      cursor: pointer;
      background: url(~image/close.svg) no-repeat;
      background-size: 14px;
      background-position: right;
      &:hover {
        color: #929ca9;
        background-image: url(~image/close.svg);
        background-repeat: no-repeat;
        background-color: #e8ebef;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        background-position: center;
        width: 24px;
        height: 24px;
        margin-top: -2px;
        margin-right: -6px;
      }
    }
  }
  .confirm-body{
    line-height: 20px;
    padding: 0 24px;
    .folderName, .dcSelect{
      span{
        font-size: 14px;
        line-height: 38px;
      }
    }
    .el-select{
      width: 287px;
      float: right;
      .el-input--suffix .el-input__inner {
        height: 34px;
      }
    }
  }
  .confirm-footer{
    padding: 24px;
    text-align: right;
    height: 38px;
    line-height: 38px;
    .confirm-btn{
      display: inline-block;
      width: 80px;
      height: 38px;
      font-size: 14px;
      cursor: pointer;
      line-height: 38px;
      border-radius: 2px;
      text-align: center;
      margin-left: 8px;
    }
  }
}
.disabled-status, #create-file{
  min-width: 80px;
  height: 32px;
  line-height: 30px;
  padding: 0;
  position: relative;
  > i {
    margin-left: 7px;
    display: inline-block;
    transform: translateY(1px);
  }
}
.filename-input{
  width: 287px;
  height: 38px;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  outline: 0;
  padding: 0 15px;
  float: right;
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  &.input-error {
    border-color: red;
  }
  &:focus {
    border: 1px solid #66afe9;
  }
}
.create-option{
  min-width: 148px;
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: white;
  position: absolute;
  top: 33px;
  right: 0;
  z-index: 1000;
  text-align: left;
  padding: 0px;
  border: 1px solid #c4c4c4;
  box-shadow: 0 1px 6px rgba(0,0,0,.4), 0 1px 0 rgba(255,255,255,.5) inset;
  border-radius: 2px;
  li{
    list-style: none;
    padding: 0 18px;
    line-height: 34px;
    color: #282e3d;
  }
  li:hover{
    cursor: pointer;
    background-color: #e8ebef;
    color: #282e3d;
  }
}
.el-dropdown-menu.create-dropdown{
  padding: 8px 0;
  margin-top: 4px;
  background: #FFFFFF;
  border: 1px solid #E8EBEF;
  box-shadow: 0 10px 20px 0 rgba(0,0,0,0.13);
  border-radius: 2px;
  overflow: hidden;
  .el-dropdown-menu__item{
    padding: 0 17px;
    color: #1b2733;
    height: 36px;
    &:hover{
      background: #F6F7FA;
      color: inherit;
    }
  }
  .item{
    display: inline-block;
    width: 166px;
    height: 36px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    svg{
      width: 20px;
      height: 20px;
      display: inline-block;
      vertical-align: text-bottom;
      margin-right: 12px;
      &.template-folder {
        height: 15px;
      }
      &.template-file {
        height: 17px;
      }
    }
  }
  .line{
    display: inline-block;
    height: 0;
    border-top: 1px solid #E8EBEF;
    margin: 8px 0;
    margin-left: 16px;
    width: 168px;
  }
  &::-webkit-scrollbar {
    width: 6px;
    height: 4px;
    margin-right: 4px;
  }
  &::-webkit-scrollbar-thumb  {
    opacity: 0.6;
    background: #C1C7CD;
    border-radius: 100px;
  }
}
</style>
